__turbopack_context__.v({
  "rating-average": "weFydG_rating-average",
  "rating-container": "weFydG_rating-container",
  "rating-container-compact": "weFydG_rating-container-compact",
});
